export function getBirthdays(state) {
  return state.birthdays
}